export default __webpack_public_path__ + "static/media/DatasetAdd.76cd3c70.svg";